import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  emptyStateContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 3,
    margin: 2,
    borderRadius: theme.spacing(0.625),
  },
  emptyStateText: {
    textAlign: 'center' as const,
    color: theme.palette.text.secondary,
    maxWidth: 600,
  },
});
